import { Injectable, inject } from '@angular/core';
import { CompaniesStore, Company } from '@dges/modules/portfolio/domain';
import { Actions, ofType } from '@ngrx/effects';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as CompaniesActions from './companies.actions';
import * as CompaniesSelectors from './companies.selectors';

@Injectable()
export class CompaniesFacade implements CompaniesStore {
  private store = inject(Store);
  private actions$ = inject(Actions);

  loaded$ = this.store.pipe(select(CompaniesSelectors.getCompaniesLoaded));
  allCompanies$ = this.store.pipe(select(CompaniesSelectors.getAllCompanies));
  selectedCompanies$ = this.store.pipe(select(CompaniesSelectors.getSelected));

  init() {
    this.store.dispatch(CompaniesActions.init());
  }

  addCompany(company: Company) {
    this.store.dispatch(CompaniesActions.addCompany({ company }));
  }

  editCompany(company: Company) {
    this.store.dispatch(CompaniesActions.editCompany({ company }));
  }

  deleteCompany(company: Company) {
    this.store.dispatch(CompaniesActions.deleteCompany({ company }));
  }

  editOrAddSuccess(): Observable<Actions> {
    return this.actions$.pipe(
      ofType(
        CompaniesActions.addCompanySuccess,
        CompaniesActions.editCompanySuccess,
      ),
    );
  }
}
